// extracted by mini-css-extract-plugin
export default {"background":"styles_background__MmJmS","logo":"styles_logo__W9j66","box":"styles_box__veOv+","title":"styles_title__4mO6s","description":"styles_description__PZiy2"};